import Container from "../../components/Container"
import Title from "../../components/Title"
import Subtitle from "../../components/Subtitle"
import Slider from "../../components/Slider"
import Card from "./components/Card"

import "./Cards.scss"

const cards = [
  "Cartões de Crédito",
  "Crédito Pessoal",
  "Empréstimo Consignado",
  "Limite da Conta",
  "Dívidas Recovery",
]
const Cards = () => {
  return (
    <section className="landing-cards">
      <Container>
        <Title>Dívidas que podem ser quitadas com o Itaú</Title>

        <Subtitle>
          Soluções para ajudar você a renegociar dívidas de cartões, empréstimos
          e mais.
        </Subtitle>
      </Container>

      <div className="landing-cards__shelf">
        <Slider content={cards}>
          {cards.map((card) => {
            return (
              <div key={card}>
                <Card content={card} />
              </div>
            )
          })}
        </Slider>
      </div>
    </section>
  )
}

export default Cards
